import {
  geoPath as d3GeoPath,
  GeoPath,
  GeoIdentityTransform,
  GeoProjection,
} from 'd3-geo';
import { Component, h, VNode } from 'preact';

import PureComponent from './PureComponent';

export interface SvgLayerProps {
  projection: GeoProjection | GeoIdentityTransform;
  width: number;
  height: number;
  render: (state: SvgLayerState) => VNode | null;
  onMouseMove?: (event: MouseEvent) => void;
  onMouseLeave?: (event: MouseEvent) => void;
}

interface SvgLayerState {
  geoPath: GeoPath;
}

class SvgLayer extends PureComponent<SvgLayerProps, SvgLayerState> {
  constructor() {
    super();

    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleMouseMove(event: MouseEvent) {
    const { onMouseMove } = this.props;

    if (onMouseMove) {
      onMouseMove(event);
    } else {
      return;
    }
  }

  handleMouseLeave(event: MouseEvent) {
    const { onMouseLeave } = this.props;

    if (onMouseLeave) {
      onMouseLeave(event);
    }
  }

  componentDidMount() {
    const geoPath = d3GeoPath(this.props.projection);

    this.setState({ geoPath });
  }

  render() {
    const { width, height } = this.props;

    return (
      <svg
        width={width}
        height={height}
        style={{
          position: 'relative',
          top: 0,
          left: 0,
          zIndex: 2,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          pointerEvents: 'none',
        }}
        viewBox={`0 0 ${width} ${height}`}
        preserveAspectRatio="xMidYMid"
        onMouseMove={this.handleMouseMove}
        onMouseLeave={this.handleMouseLeave}
      >
        <g>{this.props.render(this.state)}</g>
      </svg>
    );
  }
}

export default SvgLayer;
